import lottie from '@/components/utils/Lottie';
import infobutton from '@/components/utils/InfoButton';

export default {
    components: {
        lottie,
        infobutton
    }
}